<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Laboratories</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/labs/overview" >  Overview</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/labs/physics" >Physics Lab</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/labs/chemistry" >  Chemistry Lab</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/labs/biology" >Biology Lab</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/labs/self-management" >  Self Management</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/labs/computer" >Computer Lab</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/labs/fine" > Art & Craft</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/labs/math" > Mathematics</a>
                    </li>
                    
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>